import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import MicIcon from "@mui/icons-material/Mic";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CameraIcon from "@mui/icons-material/Camera";
import PostAddIcon from "@mui/icons-material/PostAdd";
import CreateIcon from "@mui/icons-material/Create";
import { COLORS } from "../../../../lib/colors";
import ButtonComponent from "../../../../components/ButtonComponent";
import { useTranslation } from "react-i18next";

export default function Index({
  handleCameraOpen,
  handleFileUpload,
  handleVoiceRecorder,
  handleVideoeRecorder,
  setAttachType,
}) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setAttachType();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <ButtonComponent
        backgroundColor={COLORS.purple}
        icon={<CreateIcon />}
        onClick={handleClick}
      ></ButtonComponent>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            handleCameraOpen();
          }}
        >
          <IconButton aria-haspopup="true" size="large">
            <CameraIcon titleAccess="take shot prescription" />
          </IconButton>
          {t(
            "components.AppointmentRoom.RoomFooter.prescriptionFab.takeShotPrescription"
          )}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleFileUpload();
          }}
        >
          <IconButton aria-haspopup="true" size="large">
            <AttachFileIcon titleAccess="attach prescription file" />
          </IconButton>
          {t(
            "components.AppointmentRoom.RoomFooter.prescriptionFab.attachPrescriptionFile"
          )}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleVoiceRecorder();
          }}
        >
          <IconButton aria-haspopup="true" size="large">
            <MicIcon titleAccess="attach audio prescription" />
          </IconButton>
          {t(
            "components.AppointmentRoom.RoomFooter.prescriptionFab.attachAudioPrescription"
          )}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleVideoeRecorder();
          }}
        >
          <IconButton aria-haspopup="true" size="large">
            <CameraAltIcon titleAccess="attach video prescription" />
          </IconButton>
          {t(
            "components.AppointmentRoom.RoomFooter.prescriptionFab.attachVideoPrescription"
          )}
        </MenuItem>
        <MenuItem
          onClick={() => {
            window.open("https://ep.tamin.ir", "_blank");
          }}
        >
          <IconButton aria-haspopup="true" size="large">
            <PostAddIcon titleAccess="electronic prescription tamin ejtemaei" />
          </IconButton>
          {t(
            "components.AppointmentRoom.RoomFooter.prescriptionFab.electronic"
          )}
        </MenuItem>
      </Menu>
    </div>
  );
}
